import React from 'react'
import { Footer } from './component/Footer'
import { NavBar } from './component/NavBar'
import { Home } from './component/Home'

const Landing = () => {
  return (
    <div>

        <NavBar/>
        <Home/>
        <Footer/>
      
    </div>
  )
}

export default Landing
